export default __webpack_public_path__ + "static/media/blog03.1aa1461b.png";